export const DatosAnalisis:any = {
    id_solicitud: 0,
    folio: 0,
    fecha_cotizacion:'',
    vendor: '',
    cliente: '',
    datos_generales: {},
    capacidad_pago: {},
    colateral: {}
}